import { defineStyleConfig } from '@chakra-ui/react';

export const headingTheme = defineStyleConfig({
  baseStyle: {
    fontWeight: '500'
  },
  variants: {
    h1: {
      fontSize: ['30px', '40px', '50px'],
      lineHeight: ['30px', '40px', '50px']
    },
    h2: {
      fontSize: ['25px', '30px', '40px'],
      lineHeight: ['25px', '30px', '40px']
    },
    h3: {
      fontSize: ['20px', '22px', '25px'],
      lineHeight: ['20px', '22px', '25px']
    }
  },
  defaultProps: {
    //variant: 'sectionTitle'
  }
});
